import Component from '@glimmer/component';
import { action } from '@ember/object';
import { next } from '@ember/runloop';

export default class MwSearchInput extends Component {

  @action
  focusSearch() {
    this.element.focus();
  }

  @action
  onInsertInputSearch(element) {
    this.element = element;

    if (this.args.focusOnLoad) {
      this.element.focus();
    }
  }

  @action
  closeSearch(e) {
    // close button is inside the input, stop propagation to avoid focusIn after closing
    e.stopPropagation();

    if (typeof this.args.clearSearch === 'function') {
      this.args.clearSearch();
    } else {
      this.args.doSearch?.();
    }
  }

  @action
  keyUp(event) {
    this.args.keyUp?.(event);

    if (event.keyCode === 13) {
      event.preventDefault();
      return false;
    }

    next(() => {
      // guard check in case the custom keyUp handler closed/removed the search
      if (!this.isDestroyed && !this.isDestroying) {
        this.args.doSearch?.(this.args.searchPhrase, event);
      }
    });
  }
}
